/*
 * @Description: 
 * @Autor: lkz
 * @Date: 2020-12-29 09:47:40
 * @LastEditors: lkz
 * @LastEditTime: 2020-12-29 11:09:31
 */
const roleConfig = [
  '/xinyunweb/',
  '/xinyunweb', 
  '/xinyunweb/work', 
  '/xinyunweb/home', 
  '/xinyunweb/workMenu/generalQuery/searchIndex', 
  '/xinyunweb/juridistion', 
  '/xinyunweb/rolement', 
  '/xinyunweb/newbusiness/bbx', 
  '/xinyunweb/newbusiness/button', 
  '/xinyunweb/newbusiness/personal', 
  '/xinyunweb/session/session_chat', 
  '/xinyunweb/session/session_service', 
  '/xinyunweb/taskManagement/myTask', 
  '/xinyunweb/workOrderManagement/allWorkOrder/allWorkOrderList', 
  '/xinyunweb/knowledgeBase/knowledgeSearch', 
  '/xinyunweb/intellectQuality/qualityMonitor', 
  '/xinyunweb/intellectQuality/allQuality', 
  '/xinyunweb/taskManagement/allTask', 
  '/xinyunweb/monitor/monitor', 
  '/xinyunweb/monitor/skillMonitor', 
  '/xinyunweb/monitor/seatMonitor', 
  '/xinyunweb/monitor/workMonitor', 
  '/xinyunweb/monitor/taskMonitor'
]

export default roleConfig
